export const isLoggedIn = (payload) => {
  return {
    type: 'LOGGED_IN',
    payload: payload,
  };
};

export const isLoggedOut = (payload) => {
  return {
    type: 'LOGGED_OUT',
    payload: payload,
  };
};

export const loadMessages = (payload) => {
  return {
    type: 'LOAD_MESSAGES',
    payload: payload,
  };
};

export const addLikes = (payload) => {
  return {
    type: 'ADD_LIKES',
    payload: payload,
  };
};

export const disLikes = (payload) => {
  return {
    type: 'DIS_LIKE',
    payload: payload,
  };
};

export const deleteBlog = (payload) => {
  return {
    type: 'DELETE',
    payload: payload,
  };
};

export const addPost = (payload) => {
  return {
    type: 'ADD_POST',
    payload: payload,
  };
};

export const editPost = (payload) => {
  return {
    type: 'EDIT_POST',
    payload: payload,
  };
};

export const AddReplies = (payload) => {
  return {
    type: 'REPLIES',
    payload: payload,
  };
};

export const LoadSingleMsg = (payload) => {
  return {
    type: 'LOAD_SINGLE_MESSAGE',
    payload: payload,
  };
};

export const deleteReply = (payload) => {
  return {
    type: 'DELETE_REPLY',
    payload: payload,
  };
};

export const editReply = (payload) => {
  return {
    type: 'EDIT_REPLY',
    payload: payload,
  };
};

// export const loadMessages = (payload) => {
//   return {
//     type: 'ALL_MESSAGES',
//     payload: payload,
//   };
// };
